import React from "react";
import { Checkbox, MenuItem, ListItemText, Select, OutlinedInput } from "@mui/material";
import "../TextFieldComponent/TextFieldComponent.css";
import PropTypes from "prop-types";

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
	PaperProps: {
		style: {
			maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
			width: 250
		}
	}
};

const MultiSelectDropdown = ({ options, handleChange, selectedValue, label }) => {
	return (
		<div className="box">
			<label className="left"> {label}: </label>
			<Select
				displayEmpty
				className="right"
				value={selectedValue}
				onChange={handleChange}
				multiple
				input={<OutlinedInput />}
				renderValue={(selected) => {
					if (selected.length === 0) {
						return (<MenuItem className="menuItem" disabled value="">
							{`Select ${label}`}
						</MenuItem>);
					}

					return selected.join(", ");
				}}
				MenuProps={MenuProps}
			>
				{options.map(option => <MenuItem key={option.id} value={option.label}>
					<Checkbox checked={selectedValue.indexOf(option.label) > -1} />
					<ListItemText primary={option.label} />
				</MenuItem>)}
			</Select>
		</div>);
};

MultiSelectDropdown.propTypes = {
	options: PropTypes.array,
	handleChange: PropTypes.func,
	selectedValue: PropTypes.array,
	label: PropTypes.string
};

MultiSelectDropdown.defaultProps = {
	options: [],
	handleChange: null,
	selectedValue: [],
	label: ""
};

export default MultiSelectDropdown;
